/* eslint-disable react-hooks/exhaustive-deps */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { CumulativeUsersConversion, UserFilters } from "../../components";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useDropLocations } from "../../store/useDropLocations";
import { useMarketPricing } from "../../store/useMarketPricing";
import { MaterialConversion } from "../../components/charts/MaterialConversion.chart";

function ConversionStatsNewScreen() {
  /** Hooks */
  const { getDropLocations } = useDropLocations();
  const { getAllMarketPrices } = useMarketPricing();
  /** State */
  const [period, setPeriod] = useState<
    "all" | "yearly" | "quarterly" | "monthly" | "weekly"
  >("all");
  const [year, setYear] = useState<number>(dayjs().year());
  // @ts-ignore
  const [quarter, setQuarter] = useState<"Q1" | "Q2" | "Q3" | "Q4">(
    `Q${dayjs().quarter()}` as "Q1" | "Q2" | "Q3" | "Q4"
  );
  const [month, setMonth] = useState<number>(dayjs().month());
  const [week, setWeek] = useState<Date>(new Date());
  const [selectedStores, setSelectedStores] = useState<string[]>([]);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  /** Effects */
  useEffect(() => {
    getDropLocations();
    getAllMarketPrices();
  }, []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Conversion Stats
        </h1>
        <div className="flex" />
      </div>
      {/* Filters */}
      <UserFilters
        period={period}
        year={year}
        quarter={quarter}
        month={month}
        week={week}
        selectedFilters={selectedFilters}
        selectedStores={selectedStores}
        setPeriod={setPeriod}
        setYear={setYear}
        setQuarter={setQuarter}
        setMonth={setMonth}
        setWeek={setWeek}
        setSelectedFilters={setSelectedFilters}
        setSelectedStores={setSelectedStores}
      />
      <CumulativeUsersConversion
        periodProp={period}
        yearProp={year}
        quarterProp={quarter}
        monthProp={month}
        weekProp={week}
        selectedFiltersProp={selectedFilters}
        selectedStoresProp={selectedStores}
      />
      <MaterialConversion />
    </div>
  );
}

export default withProtectedRoute(ConversionStatsNewScreen);
